const MarketingPermissions = () => null;

export default MarketingPermissions;
